import { useState } from "react";

export const useCheckoutForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    originState: "",
    cnpj: "",
    userData: {
      email: "",
      name: "",
      phone: "",
      password: "",
      affiliated: true,
      affiliate_id: 7,
      permission: 3,
      project_permission: 3,
    },
  });

  const [errors, setErrors] = useState({});

  const handleChange = (field, value, isUserData = false) => {
    if (isUserData) {
      setFormData(prev => ({
        ...prev,
        userData: {
          ...prev.userData,
          [field]: value,
        },
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [field]: value,
      }));
    }

    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Nome da empresa é obrigatório";
    if (!formData.originState.trim()) newErrors.originState = "Estado é obrigatório";
    if (!formData.cnpj.trim()) newErrors.cnpj = "CNPJ é obrigatório";
    if (!formData.userData.email.trim()) newErrors.email = "Email é obrigatório";
    if (!formData.userData.name.trim()) newErrors.userName = "Nome do usuário é obrigatório";
    if (!formData.userData.phone.trim()) newErrors.phone = "Telefone é obrigatório";
    if (!formData.userData.password.trim()) newErrors.password = "Senha é obrigatória";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.userData.email && !emailRegex.test(formData.userData.email)) {
      newErrors.email = "Email inválido";
    }

    if (formData.userData.password && formData.userData.password.length < 6) {
      newErrors.password = "Senha deve ter pelo menos 6 caracteres";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return {
    formData,
    errors,
    handleChange,
    validateForm,
  };
};